import { createSelector } from 'reselect';
import { prop } from 'ramda';

const licensing = (state) => state.licensing;

export const getLicensingFilters = createSelector(licensing, prop('filters'));
